import React from 'react';
import * as S from './References.styles';
import { GithubOutlined, LinkedinOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>Asan Olgoo</S.Text>
      <S.Icons>
        <a href="https://github.com/Asan-Olgoo" target="_blank" rel="noreferrer">
          <GithubOutlined />
        </a>
        {/* <a href="https://twitter.com/altence_team" target="_blank" rel="noreferrer">
          <TwitterOutlined />
        </a>
        <a href="https://www.facebook.com/groups/altence" target="_blank" rel="noreferrer">
          <FacebookOutlined />
        </a> */}
        <a href="https://www.linkedin.com/company/asan-olgoo" target="_blank" rel="noreferrer">
          <LinkedinOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
